<template>
<div>
    <public-head :backgroundImage="bg" subTitle="NEWS CENTER" title="新闻中心" :show="true" />
    <router-view></router-view>
</div>
</template>

<script>
export default {
    data() {
        return {
            bg: require('../assets/img/news_bg.png')
        }
    },
    mounted() {
        // if (this.$route.query.type) {

        // } else {
        //     this.$router.push({
        //         path: '/news/company'
        //     })
        // }
    }
};
</script>

<style>
</style>
